import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { theme } from '../../theme';
/**
 * This component will display a text as code.
 */
export var Code = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (_jsx(Box, __assign({ sx: {
            background: theme.palette.customGrey.xlight,
            borderRadius: 1,
        }, p: 1, component: "span" }, props, { children: _jsx("code", __assign({ style: {
                color: theme.palette.customGrey.dark || '#000',
            } }, { children: children })) })));
};
